<template>
  <div class="content">
    <top-header :type="6" placeholder="家财保障" textColor="#000" bgColor="#fff" fontSize="0.32rem" />
    <!-- <div class="flex" style="padding: 0.3rem 0">
      <div class="left">
        <img :src="objData.organLogo" alt="" />
      </div>
      <div class="right">
        <div>事务所:{{ objData.organName }}</div>
        <div>地址:{{ objData.contactAddress }}</div>
        <div>电话:{{ objData.linkPhone }}</div>
      </div>
    </div>
    <div class="flex extend">
      <div class="typeface_grey">团队介绍</div>
      <div class="typeface_black" @click="moreInfo">查看全部>></div>
    </div>
    <div class="dec typeface_greycf">
      {{ objData.bakParam1 }}
    </div> -->
    <div class="typeface_grey" style="padding-top: 0.3rem; font-size: 0.5rem;font-weight: 900;">险种介绍</div>
    <div class="item_data">
      <div class="flex extend">
        <div class="flex flex_middle">
          <div style="font-size:20px;font-weight:900">包租保家庭财产综合险</div>
        </div>
        <!-- <div class="flex_middle flex_new">
          <div class="chat" @click="toTalk(item.id)">
            <img src="@/assets/img/zx.png" alt="" />
          </div>
          <div>线上咨询</div>
        </div> -->
      </div>
      <div class="dec typeface_grey">
        一份保险，保障你我他！
        专为房东量身打造，安心成为“包租婆&包租公”
        全方位应对房屋损失、租金损失、管道破裂，三者风险
        房东大人必买神器
        为租客提供保障，为房东增添魅力和吸引力
        比N家，
        每天不到3毛钱，安心出租一整年
      </div>
      <div style="text-align: right;padding-top: 10px;" class="typeface_grey" @click="buy(1)">
        了解详情>>
      </div>
    </div>
    <div class="item_data">
      <div class="flex extend">
        <div class="flex flex_middle">
          <div style="font-size:20px;font-weight:900">“居家无忧”家庭财产组合保险</div>
        </div>
        <!-- <div class="flex_middle flex_new">
          <div class="chat" @click="toTalk(item.id)">
            <img src="@/assets/img/zx.png" alt="" />
          </div>
          <div>线上咨询</div>
        </div> -->
      </div>
      <div class="dec typeface_grey">
        保障项目繁多，内容涵盖家庭财产、宠物、熊孩子、保姆等各种风险保障
      </div>
      <div style="text-align: right;padding-top: 10px;" class="typeface_grey" @click="buy(2)">
        了解详情>>
      </div>
    </div>
    <div class="item_data">
      <div class="flex extend">
        <div class="flex flex_middle">
          <div style="font-size:20px;font-weight:900">“安心安家”综合责任保险</div>
        </div>
        <!-- <div class="flex_middle flex_new">
          <div class="chat" @click="toTalk(item.id)">
            <img src="@/assets/img/zx.png" alt="" />
          </div>
          <div>线上咨询</div>
        </div> -->
      </div>
      <div class="dec typeface_grey">
        给家庭一份专属保障，包括家庭成员责任
        、家政服务人员意外责任
        、高空坠物责任、代看护责任、宠物第三者责任
        、非机动车辆第三者责任
      </div>
      <div style="text-align: right;padding-top: 10px;" class="typeface_grey" @click="buy(3)">
        了解详情>>
      </div>
    </div>
    <div class="item_data" style="border-bottom:0;padding-bottom:0.5rem">
      <div class="flex extend">
        <div class="flex flex_middle">
          <div style="font-size:20px;font-weight:900">家庭成员责任险</div>
        </div>
        <!-- <div class="flex_middle flex_new">
          <div class="chat" @click="toTalk(item.id)">
            <img src="@/assets/img/zx.png" alt="" />
          </div>
          <div>线上咨询</div>
        </div> -->
      </div>
      <div class="dec typeface_grey">
        包含熊孩子看护、宠物饲养、家政服务等多方面，适用场景广泛
        根据家庭成员数量定制保险方案，灵活性强
        百元保费享受百万元责任限额，价格实惠
      </div>
      <div style="text-align: right;padding-top: 10px;" class="typeface_grey" @click="buy(4)">
        了解详情>>
      </div>
    </div>
    <div class="gy" @click="consulting">客服咨询</div>
  </div>
</template>
<script>
import qs from "qs";
import { Dialog } from "vant";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      objData: {},
      lsList: [],
      link: "",
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    // this.initData();
  },
  methods: {
    consulting() {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfc0394d91214dc67fa'
    },
    buy(num) {
      Dialog.confirm({
        title: "风险提醒",
        confirmButtonText: "同意并继续",
        cancelButtonText: "取消",
        message:
          "您所查看的内容为合作方提供的外部链接。徐州市房地产信息网仅提供入口及广告接入，不承担产品投资、兑付和风险管理责任。一切产品要素和交易规则均以合作方公司提供信息为准。\n\n是否同意跳转到外部链接？",
      })
        .then(() => {
          this.jumpDetail(num)
        })
        .catch(() => {
          // on cancel
        });
    },
    jumpDetail(num) {
      switch (num) {
        case 1:
          window.location.href = 'http://gxb.e.cic.cn/gxbweixinouter/o2o/html/product/nonAuto/sharePages/bzbShare.html?openId=ovFa5s0XVOKzovNSICarfGYvSWA0'
          break;
        case 2:
          window.location.href = 'http://gxb.e.cic.cn/gxbweixinouter/o2o/html/product/nonAuto/sharePages/jjwyShare.html?openId=ovFa5s0XVOKzovNSICarfGYvSWA0'
          break;
        case 3:
          window.location.href = 'http://gxb.e.cic.cn/gxbweixinouter/o2o/html/product/nonAuto/sharePages/10184Share.html?openId=ovFa5s0XVOKzovNSICarfGYvSWA0'
          break;
        case 4:
          window.location.href = 'http://gxb.e.cic.cn/gxbweixinouter/o2o/html/product/nonAuto/sharePages/jtcyShare.html?openId=ovFa5s0XVOKzovNSICarfGYvSWA0'
          break;
      }
    }
  },
};
</script>
<style lang="less" scoped>
.content {
  font-size: 0.3rem;
  padding: 0 0.3rem;

  .gy {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: #99ccff;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
  }

  .item_data {
    padding: 0.2rem;
    border-bottom: 3px solid #ccc;
  }

  .typeface_grey {
    color: #808080;
  }

  .typeface_greycf {
    color: #cfcfcf;
  }

  .typeface_black {
    color: #000;
  }

  .head_photo {
    margin-right: 0.3rem;
    width: 0.8rem;
    height: 0.8rem;

    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
  }

  .chat {
    width: 0.6rem;
    height: 0.6rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .flex_new {
    display: flex;
    flex-direction: column;
  }

  .flex_middle {
    align-items: center;
  }
}

.left {
  width: 40%;

  img {
    width: 80%;
  }
}

.right {
  width: 60%;

  div {
    line-height: 0.6rem;
  }
}

.flex {
  display: flex;
}

.extend {
  justify-content: space-between;
  padding: 0.2rem 0;
}

.dec {
  line-height: 0.5rem;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>